import { downloadNewsAttachment, getNews, getNewsList, translateNews, removeNewsAttachment, saveNewsAttachment, saveNews, deleteNews } from './news.admin.api';
import { getEvents, getEvent, saveEvent, getEnrollments, deleteEvent } from './events.admin.api';
import { getPolls, getPoll, savePoll, deletePoll, getAnswers } from './polls.admin.api';
import { getResources, getResource, deleteResource, download as downloadResource, saveResource } from './resources.admin.api';
import { getFaqList, getFaq, saveFaq, deleteFaq, sort as sortFaq } from './faq.admin.api';
import { getPages, getPage, getPageGroups, deletePage, sort as sortPages, sortPageAttachments, savePage, savePageAttachment, downloadPageAttachment, removePageAttachment } from './pages.admin.api';
import { getBenefits, getBenefit, saveBenefit, deleteBenefit, sort as sortBenefits } from './benefits.admin.api';
import { getChannels, getChannel, saveChannel } from './chat.admin.api';
import { getFeedbacks, saveFeedbackMessage, getFeedback, updateFeedback, getFeedbackCount, downloadLegacyFeedbackAttachment, downloadFeedbackAttachment, getFeedbackManagerLog, getFeedbackManagers, addFeedbackManager, updateFeedbackManager, removeFeedbackManager, getFeedbackCategories, getFeedbackCategory, saveFeedbackCategory } from './feedback.admin.api';
import { searchUsers, getTenantAdmins, getAllAdmins, getUser, getUsers, getNewUsers, getNotLoggedInUsers, getUserAdminGroups, getUserGroups, importUser, removeUser, saveUser, removeUserImage, updateUserImage, inviteUser } from './users.admin.api';
import { getGroups, getGroupMembers, getGroupAdmins } from './groups.admin.api';

import { getFeedbackPolicy, saveFeedbackPolicy } from './settings.admin.api';
import { getChangelog } from './changelog.admin.api';
import { uploadImage } from './upload.admin.api';
import { getWallpapers, saveWallpaper, deleteWallpaper, sortWallpapers } from './wallpapers.admin.api';
import { translateText } from './translate.admin.api';

const adminApi = {

    // Translate
    translateText,

    // News
    downloadNewsAttachment,
    getNews,
    getNewsList,
    removeNewsAttachment,
    saveNewsAttachment,
    saveNews,
    deleteNews,

    // Events
    getEvents,
    getEvent,
    saveEvent,
    getEnrollments,
    deleteEvent,

    // Polls
    getPolls,
    getPoll,
    savePoll,
    deletePoll,
    getAnswers,

    // Resources
    getResources,
    getResource,
    deleteResource,
    downloadResource,
    saveResource,

    // Faq
    getFaqList,
    getFaq,
    saveFaq,
    deleteFaq,
    sortFaq,

    // Pages
    getPages,
    getPage,
    getPageGroups,
    savePage,
    savePageAttachment,
    sortPageAttachments,
    deletePage,
    sortPages,
    downloadPageAttachment,
    removePageAttachment,

    getWallpapers,
    saveWallpaper,
    deleteWallpaper,
    sortWallpapers,

    // Benefits
    getBenefits,
    getBenefit,
    saveBenefit,
    deleteBenefit,
    sortBenefits,

    // Feedback
    getFeedbacks,
    getFeedback,
    updateFeedback,
    getFeedbackCount,
    downloadLegacyFeedbackAttachment,
    downloadFeedbackAttachment,
    getFeedbackManagers,
    getFeedbackManagerLog,
    addFeedbackManager,
    updateFeedbackManager,
    removeFeedbackManager,
    saveFeedbackMessage,
    getFeedbackCategories,
    getFeedbackCategory,
    saveFeedbackCategory,

    // Chat
    getChannels,
    getChannel,
    saveChannel,

    // Users
    getUsers,
    getNewUsers,
    getNotLoggedInUsers,
    searchUsers,
    getUserAdminGroups,
    getUserGroups,
    getUser,
    saveUser,
    updateUserImage,
    removeUserImage,
    getTenantAdmins,
    getAllAdmins,
    removeUser,
    importUser,
    inviteUser,


    // Groups
    getGroups,
    getGroupMembers,
    getGroupAdmins,

    // Settings
    getFeedbackPolicy,
    saveFeedbackPolicy,

    // Upload
    uploadImage,

    // Changelog
    getChangelog
};

export default adminApi;